import axios from 'lib/axios'

const getBetesaReport = async (userTestId: number, isInterpretation?: boolean) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/pdf/betesa`
  const data = {
    user_test_id: userTestId,
    isInterpretation,
  }
  try {
    const response = await axios.post(PATH, data)
    return response.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export default getBetesaReport
